module.exports = __webpack_public_path__ + "img/hf_model_home_lg.png";